exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4343",
  IMG_URL: "https://yooestatenode.profcymadev.com:4349",

  // IMG_URL: "https://hindustansolarnode.profcymadev.com:1518",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",

  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  user_status: {
    Requested: 1,
    Approved: 2,
    Rejected: 3,
  },

  property_status: {
    Requested: 1,
    InProgress: 2,
    Approved: 3,
    Rejected: 4,
  },

  property_type: {
    Residential: 1,
    Commercial: 2,
    Plot: 3,
    Villa: 4,
  },
};
